import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import LogoImage from '../images/ui/Logo.png';
import LogoImageHover from '../images/ui/Logo(Hover).png';
import LogoImageBW from '../images/ui/Logo_01(BNW)(purple).png';
import LogoImageBWHover from '../images/ui/Logo_02(BNW)(purple).png';

import IconDildo from '../icon/DildoIcon(Color).svg';
import IconGrinder from '../icon/GrinderIcon(Color).svg';
import IconMasturbator from '../icon/MastubartorsIcon(Color).svg';
import IconSheath from '../icon/SheathIcon(Color).svg';
import IconTunnel from '../icon/TunnelPlugIcon(Color).svg';
import IconAccessories from '../icon/accessories.svg';
import IconMerchandise from '../icon/shirt-solid.svg';

import IconDildoHover from '../icon/DildoIcon(Color)-hover.svg';
import IconGrinderHover from '../icon/GrinderIcon(Color)-hover.svg';
import IconMasturbatorHover from '../icon/MastubartorsIcon(Color)-hover.svg';
import IconSheathHover from '../icon/SheathIcon(Color)-hover.svg';
import IconTunnelHover from '../icon/TunnelPlugIcon(Color)-hover.svg';
import IconAccessoriesHover from '../icon/accessories-hover.svg';
import IconMerchandiseHover from '../icon/shirt-solid-hover.svg';

import Cart from './Cart';
import HamburgerMenu from './HamburgerMenu';
import SectionMenu from './SectionMenu';
import Select from 'react-select';
import useViewport from '../hooks/useViewport';
import "../style/Header.css";
import RightMenu from './RightMenu';

import DropProgress from './DropProgress';

import { useCurrency } from '../contexts/CurrencyContext';
import { shouldShowCurrencySelector } from '../utils/currencySelector';

import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { languageOptions, getSelectedLanguageOption } from '../i18n';

function Header() {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const { isMobileView, isTinyMobileView } = useViewport();
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const [iconStates, setIconStates] = useState({
    dildo: IconDildo,
    tunnel: IconTunnel,
    masturbator: IconMasturbator,
    sheath: IconSheath,
    grinder: IconGrinder,
    accessories: IconAccessories,
    merchandise: IconMerchandise,
  });

  const navigate = useNavigate();
  const location = useLocation();

  const isHomePage = location.pathname === '/';
  const showCurrencySelector = shouldShowCurrencySelector(location.pathname);

  const scrollToSection = (section) => {
    navigate(`/products#${section}`);
    setTimeout(() => {
      const anchor = document.querySelector(`#${section}`);
      if (anchor) {
        const headerOffset = 190;
        const elementPosition = anchor.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY  - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 100);
  };

  const [isOffScreen, setIsOffScreen] = useState(false);

  const isHeaderOffScreen = () => {
    window.addEventListener('scroll', function(e){
      if (window.scrollY > 225) {
        setIsOffScreen(true);
      } else {
        setIsOffScreen(false);
      }
    });
  }

  isHeaderOffScreen();


  const handleMouseOver = (key, hoverIcon) => {
    setIconStates((prev) => ({ ...prev, [key]: hoverIcon }));
  };

  const handleMouseOut = (key, defaultIcon) => {
    setIconStates((prev) => ({ ...prev, [key]: defaultIcon }));
  };

  const optionsCategories = [
    { value: 'dildos', label: <p class="product-header-component" onClick={() => scrollToSection('dildos')}>Dildos</p>},
    { value: 'tunnels', label: <p class="product-header-component" onClick={() => scrollToSection('plugs')}>Tunnels</p> },
    { value: 'masturbators', label: <p class="product-header-component" onClick={() => scrollToSection('masturbators')}>Masturbators</p> },
    { value: 'wearables', label: <p class="product-header-component" onClick={() => scrollToSection('wearables')}>Wearables</p> },
    { value: 'grinders', label: <p class="product-header-component" onClick={() => scrollToSection('grinders')}>Grinders</p> },
    { value: 'accessories', label: <p class="product-header-component" onClick={() => scrollToSection('accessories')}>Accessories</p> },
    { value: 'merchandise', label: <p class="product-header-component" onClick={() => scrollToSection('merchandise')}>Merchandise</p> },
  ];

  const selectedLanguageOption = getSelectedLanguageOption(i18n.language);

  const handleLanguageSelectChange = (selectedOption) => {
    if (selectedOption) {
      i18n.changeLanguage(selectedOption.value);
    }
  };

  const { selectedCurrency, currencyOptions, handleCurrencyChange } = useCurrency();
  const selectedCurrencyOption = currencyOptions.find(opt => opt.value === selectedCurrency.toLowerCase());

  return (
    <header
      className={
          isHomePage
            ? !isOffScreen
              ? 'background-color-out'
              : 'background-color-header'
            : 'background-color-header-no-transition'
        }
      >

      <DropProgress percentage={50}/>

      <div class={isHomePage ? isOffScreen ? 'home-menu-drop-shadow header-container' : 'header-container' : 'header-container'}>
      <Link className="header-brand" to="/" aria-label="Awootoys Home">
        <h1 className="brand-name">Awootoys</h1>
        <span className="brand-slogan">{t('header.slogan')}</span>
      </Link>


        <div className="logo-container">
          <div>
            <Link to="/">
              {!isHomePage &&
                <img
                className="logo-image"
                src={isLogoHovered ? LogoImageHover : LogoImage}

                alt="Awootoys logo - premium fantasy sex toys"
                onMouseEnter={() => setIsLogoHovered(true)}
                onMouseLeave={() => setIsLogoHovered(false)}
              />
              }
              
              {isHomePage &&
                <img
                className="logo-image"
                src={isLogoHovered && isOffScreen ? LogoImageHover : isLogoHovered ? LogoImageBWHover : isOffScreen ? LogoImage : LogoImageBW}

                alt="Awootoys logo - premium fantasy sex toys"
                onMouseEnter={() => setIsLogoHovered(true)}
                onMouseLeave={() => setIsLogoHovered(false)}
                />
                }
              </Link>
            </div>
          </div>

        {!isMobileView &&
        <nav class="header-navigation">
          <Link class="navigation-link" to="/products">{t('header.allProducts')}</Link>
          {/* <Link class="navigation-link" to="/stock">In stock</Link> */}
        </nav>
        }

        <div class="account-container">
          {!isMobileView && <div class="account-icon-container">
            {user ? ( 
              <FontAwesomeIcon class="account-section-icon" icon={faUser} onClick={() => navigate("/account/update")} aria-label="User account settings"/>
            ) : (
              <a class="navigation-link" onClick={() => navigate("/account/login")} aria-label="User account log in">{t('header.logIn')}</a>
            )}
            <Cart />
          </div>}

          {isMobileView &&
          <div class="account-icon-container">
            <HamburgerMenu class="account-container" />
            <Cart />
          </div>
          }

          {!isMobileView && showCurrencySelector && <Select
            className="header-currency-select"
            classNamePrefix="currency-select"
            styles={{
              container: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple) !important",
              }),
              control: (baseStyles) => ({
                ...baseStyles,
                width: "120px",
                fontSize: "12px",
                fontWeight: "bold",
                backgroundColor: "transparent",
                color: "var(--darker-purple) !important",
                borderWidth: "2px",
                borderColor: "var(--darker-purple)",
                boxShadow: "none",
                "&:hover": {
                  borderColor: "var(--darker-purple)",
                },
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple) !important",
                fontWeight: "bold",
                fontSize: "14px",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple) !important",
              }),
              valueContainer: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple) !important",
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple) !important",
              }),
              menu: (baseStyles) => ({
                  ...baseStyles,
                  width: "120px"
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: state.isSelected ? "#FFFFFF" : "transparent",
                color: state.isSelected ? "#FFFFFF" : "var(--darker-purple)",
                fontWeight: "bold",
                backgroundImage: state.options[state.options.length - 1] === state.data ? "none" : "linear-gradient(black, black)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "calc(100% - 25px) 1px",
                backgroundPosition: "12.5px bottom",
              }),
            }}
            options={currencyOptions}
            value={selectedCurrencyOption}
            onChange={handleCurrencyChange}
          />}
          
          {!isMobileView && process.env.REACT_APP_REGION === "CA" && <Select
            id="language-select"
            className="language-select"
            options={languageOptions}
            value={selectedLanguageOption}
            onChange={handleLanguageSelectChange}
            isSearchable={false}
            placeholder="English"
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                width: "120px",
                fontSize: "12px",
                fontWeight: "bold",
                backgroundColor: "transparent",
                color: "var(--darker-purple)",
                borderWidth: "2px",
                borderColor: "var(--darker-purple)",
                boxShadow: "none",
                "&:hover": {
                  borderColor: "var(--darker-purple)",
                },
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple)", // Selected value color
                fontWeight: "bold",
                fontSize: "14px",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                color: "var(--darker-purple)",
              }),
              menu: (baseStyles) => ({
                  ...baseStyles,
                  width: "120px",
                  backgroundColor: "#e3e3e3"
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: state.isSelected
                ? "#FFFFFF" // Background when selected
                : "transparent",
                color: "black", // Text color of items
                fontWeight: "bold",
                backgroundImage: state.options[state.options.length - 1] === state.data ? "none" : "linear-gradient(black, black)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "calc(100% - 25px) 1px",
                backgroundPosition: "12.5px bottom",
              }),
            }}
            />}
        </div>
      </div>

      {!isHomePage && (
        <div class="products-header-container">

        {!isTinyMobileView &&
          <div class="elevated-edge-header edge-right"></div>
        }

        {!isTinyMobileView &&
          <div class="products-header-content-wide">
            <div class="elevated-product-header-item">
              <div class="product-header-item left"
                  onMouseOver={() => handleMouseOver('dildo', IconDildoHover)}
                  onMouseOut={() => handleMouseOut('dildo', IconDildo)}
                  onClick={() => scrollToSection('dildos')}
                  aria-label="Dildo section"
                >
                <img class="product-header-icon-dildo"  src={iconStates.dildo} alt="header-logo"/>
                <p class="product-header-component">{t('categories.dildosCategory')}</p>
              </div>
            </div>

            {/* <div class="elevated-product-header-item">
              <div class="product-header-item"
                  onMouseOver={() => handleMouseOver('tunnel', IconTunnelHover)}
                  onMouseOut={() => handleMouseOut('tunnel', IconTunnel)}
                  onClick={() => scrollToSection('plugs')}
                >
                <img class="product-header-icon" src={iconStates.tunnel} alt="header-logo"/>
                <p class="product-header-component">Tunnels</p>
              </div>
            </div> */}

            <div class="elevated-product-header-item">
              <div class="product-header-item"
                  onMouseOver={() => handleMouseOver('masturbator', IconMasturbatorHover)}
                  onMouseOut={() => handleMouseOut('masturbator', IconMasturbator)}
                  onClick={() => scrollToSection('masturbators')}
                >
                <img class="product-header-icon" src={iconStates.masturbator} alt="header-logo"/>
                <p class="product-header-component">{t('categories.masturbatorsCategory')}</p>
              </div>
            </div>

            {/* <div class="elevated-product-header-item">
              <div class="product-header-item"
                  onMouseOver={() => handleMouseOver('sheaths', IconSheathHover)}
                  onMouseOut={() => handleMouseOut('sheaths', IconSheath)}
                  onClick={() => scrollToSection('sheaths')}
                >
                <img class="product-header-icon" src={iconStates.sheath} alt="header-logo"/>
                <p class="product-header-component">Sheaths</p>
              </div>
            </div> */}

            {/* <div class="elevated-product-header-item">
              <div class="product-header-item"
                  onMouseOver={() => handleMouseOver('grinder', IconGrinderHover)}
                  onMouseOut={() => handleMouseOut('grinder', IconGrinder)}
                  onClick={() => scrollToSection('grinders')}
                >
                <img class="product-header-icon" src={iconStates.grinder} alt="header-logo"/>
                <p class="product-header-component">Grinders</p>
              </div>
            </div> */}

            <div class="elevated-product-header-item">
              <div class="product-header-item"
                  onMouseOver={() => handleMouseOver('accessories', IconAccessoriesHover)}
                  onMouseOut={() => handleMouseOut('accessories', IconAccessories)}
                  onClick={() => scrollToSection('accessories')}
                  aria-label="Accessories section"
                >
                <img class="product-header-icon-accessories" src={iconStates.accessories} alt="header-logo"/>
                <p class="product-header-component">{t('categories.accessoriesCategory')}</p>
              </div>
            </div>

            <div class="elevated-product-header-item">
              <div class="product-header-item"
                  onMouseOver={() => handleMouseOver('merchandise', IconMerchandiseHover)}
                  onMouseOut={() => handleMouseOut('merchandise', IconMerchandise)}
                  onClick={() => scrollToSection('merchandise')}
                  aria-label="Merchandise section"
                >
                <img class="product-header-icon-merchandise" src={iconStates.merchandise} alt="Merchandise section image"/>
                <p class="product-header-component">{t('categories.merchandiseCategory')}</p>
              </div>
            </div>

          </div>
        }
        {!isTinyMobileView &&
          <div class="elevated-edge-header edge-left"></div>
        }

        {isTinyMobileView &&
          <SectionMenu class="beans"></SectionMenu>
        }
        </div>
      )}

      <RightMenu menu={"cart"}/>
    </header>
  );
}

export default Header;